import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/DashboardLayout";
import PostJob from "../../components/post_job/PostJob";
import ClickOutsideWrapper from "../../components/ClickOutSideWrapper";
import { useNavigate } from "react-router-dom";
import { auth, db, ref } from "../../utilities/firebaseConfig";
import { get, onValue } from "firebase/database";
import timeicon from "../../assets/ttime.svg";
import calendericon from "../../assets/tcalendar.svg";

function ClientDashboard() {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [btnactive, setBtnActive] = useState("All tasks");
  const [showorientation, setShowOrientation] = useState("grid");
  const [sortam, setSortam] = useState("all");
  const [activeJobs, setActiveJobs] = useState([]);
  const user = auth.currentUser;
  useEffect(() => {
    const fetchActiveJobs = () => {
      const user = auth.currentUser;
      if (!user) {
        return;
      }

      const jobsRef = ref(db, "jobs");
      onValue(jobsRef, async (snapshot) => {
        if (snapshot.exists()) {
          const jobsData = Object.entries(snapshot.val()).map(([id, job]) => ({
            id,
            ...job,
          }));

          // Filter for jobs that belong to the current user.
          let filteredJobs = jobsData.filter((job) => job.userId === user.uid);

          filteredJobs = filteredJobs.filter(
            (job) => job.status !== "completed" && job.status !== "cancelled"
          );

          // Apply status filter only if it's NOT "all".
          if (sortam !== "all") {
            filteredJobs = filteredJobs.filter((job) => job.status === sortam);
          }

          // For each filtered job, fetch the technician details (if technicianId exists).
          const jobsWithTechDetails = await Promise.all(
            filteredJobs.map(async (job) => {
              if (job.technicianId) {
                const techRef = ref(db, `technicians/${job.technicianId}`);
                const techSnapshot = await get(techRef);
                if (techSnapshot.exists()) {
                  return { ...job, technician: techSnapshot.val() };
                }
              }
              return job;
            })
          );

          setActiveJobs(jobsWithTechDetails);
        } else {
          setActiveJobs([]);
        }
      });
    };

    fetchActiveJobs();
  }, [sortam]); // 👈 now depends on selectedStatus

  const navlinkstas = [
    {
      id: 0,
      name: "All tasks",
    },
  ];

  const sortlist = [
    {
      id: 0,
      name: "all",
    },
    {
      id: 1,
      name: "pending",
    },
    {
      id: 2,
      name: "in progress",
    },
    {
      id: 3,
      name: "accepted",
    },
    {
      id: 4,
      name: "rejected",
    },
  ];

  function formatDate(dateString) {
    const date = new Date(dateString);
    // Arrays for the short names of days and months.
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the components of the date.
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${dayName}, ${monthName} ${day}, ${year}`;
  }

  const formatWhatsAppTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();

    const diffInMs = now - date;
    const diffInSeconds = Math.floor(diffInMs / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInWeeks = Math.floor(diffInDays / 7);
    const yearDiff = now.getFullYear() - date.getFullYear();
    const monthDiff = now.getMonth() - date.getMonth() + yearDiff * 12;

    const isToday = date.toDateString() === now.toDateString();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();

    if (diffInSeconds < 60) {
      return "Just now";
    } else if (isToday) {
      return "Today";
    } else if (isYesterday) {
      return "Yesterday";
    } else if (diffInDays < 7) {
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    } else if (diffInWeeks < 4) {
      return `${diffInWeeks} week${diffInWeeks > 1 ? "s" : ""} ago`;
    } else if (monthDiff >= 1) {
      return `${monthDiff} month${monthDiff > 1 ? "s" : ""} ago`;
    } else {
      return date.toLocaleDateString(undefined, {
        weekday: "short",
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    }
  };

  return (
    <>
      <PostJob isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
      <DashboardLayout>
        <div className='theclientdsh'>
          <div className='theclientdshtop'>
            <button
              className='theclidashbtn'
              onClick={() => setModalOpen(true)}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 24 24'
                width='18'
                height='18'
                fill='#3b3b3b'
              >
                <path d='M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z'></path>
              </svg>
            </button>
            <h1 className='theclidashbtntit'>New task</h1>
          </div>
          <div className='thespac'></div>
          <div className='theclientdasnav'>
            <div className='theclientdasleft'>
              {navlinkstas.map((link, index) => (
                <button
                  className={`
                   ${
                     btnactive === link.name ? "activebtn" : "notactivebtn"
                   } theclientbtnnav`}
                  key={link.id}
                  onClick={() => setBtnActive(link.name)}
                >
                  {link.name}
                </button>
              ))}
            </div>
            <div className='theclientdashright'>
              <button
                className='thcligrid'
                onClick={() => setShowOrientation("grid")}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  width='18'
                  height='18'
                  fill={showorientation === "grid" ? "#ff6250" : "#3b3b3b"}
                >
                  <path d='M21 3C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H21ZM11 13H4V19H11V13ZM20 13H13V19H20V13ZM11 5H4V11H11V5ZM20 5H13V11H20V5Z'></path>
                </svg>
              </button>
              <button
                className='thclilist'
                onClick={() => setShowOrientation("list")}
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 24 24'
                  width='18'
                  height='18'
                  fill={showorientation === "list" ? "#ff6250" : "#3b3b3b"}
                >
                  <path d='M11 4H21V6H11V4ZM11 8H17V10H11V8ZM11 14H21V16H11V14ZM11 18H17V20H11V18ZM3 4H9V10H3V4ZM5 6V8H7V6H5ZM3 14H9V20H3V14ZM5 16V18H7V16H5Z'></path>
                </svg>
              </button>
              <div className='thcdropsam'>
                <button className='thcdrop' onClick={() => setShowSort(true)}>
                  <label htmlFor=''>{sortam}</label>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 24 24'
                    width='36'
                    height='36'
                    fill='currentColor'
                  >
                    <path d='M12 14L8 10H16L12 14Z'></path>
                  </svg>
                </button>
                {showSort && (
                  <ClickOutsideWrapper
                    onClickOutside={() => setShowSort(false)}
                  >
                    <div className='sortfrcasn'>
                      {sortlist.map((sort, index) => (
                        <button
                          onClick={() => {
                            setSortam(sort.name);
                            setShowSort(false);
                          }}
                          id={sort.id}
                          className={`thesortshow ${
                            sortam === sort.name
                              ? "thesortshowactive"
                              : "thesortshownotactive"
                          }`}
                        >
                          {sort.name}
                        </button>
                      ))}
                    </div>
                  </ClickOutsideWrapper>
                )}
              </div>
            </div>
          </div>
          <div className='thespac'></div>
          {showorientation === "grid" && (
            <div className='thetasklistcnt'>
              {activeJobs.length > 0 ? (
                activeJobs.map((job) => (
                  <div key={job.id} className='activetaskcnttop hover-wrapper'>
                    <div className='hover-overlay'>
                      <div className='activetaskcntdnae'></div>
                      <button
                        onClick={() => navigate(`/client/job/${job.id}`)}
                        className='select-button'
                      >
                        Select Task
                      </button>
                    </div>
                    <div className='activetaskcnt'>
                      <div className='activetaskcntleft'>
                        <p className='jobtitle'>{job.jobtitle}</p>
                        <div className='thegap'></div>
                        <div className='btsdetitemm'>
                          <img
                            src={calendericon}
                            alt=''
                            className='btsdeticonn'
                          />
                          <label htmlFor='' className='btsdettlabell'>
                            {formatDate(job.date)}
                          </label>
                        </div>
                        {/* <div className='btsdetitemm'>
                        <img
                          src={locationicon}
                          alt=''
                          className='btsdeticonn'
                        />
                        <label htmlFor='' className='btsdettlabell'>
                          {job.address}
                        </label>
                      </div> */}
                        <div className='btsdetitemm'>
                          <img src={timeicon} alt='' className='btsdeticonn' />
                          <label htmlFor='' className='btsdettlabell'>
                            {job.timeOfDay}
                          </label>
                        </div>
                      </div>
                      <div className='thegap'></div>
                      {job.technician && (
                        <div className='mytaskcntitem-rightt'>
                          <div className='theflexsa'>
                            <div className='theflexsaleft'>
                              <img
                                src={job.technician.profileUrl}
                                alt=''
                                className='activetaskimgg'
                              />
                              <div
                                className={
                                  job.technician.rating > 3.5
                                    ? "wlitoprgreen"
                                    : "wlitopryellow"
                                }
                              >
                                <svg
                                  width='12'
                                  height='12'
                                  viewBox='0 0 15 15'
                                  fill='#fff'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M7.22303 0.665992C7.32551 0.419604 7.67454 0.419604 7.77702 0.665992L9.41343 4.60039C9.45663 4.70426 9.55432 4.77523 9.66645 4.78422L13.914 5.12475C14.18 5.14607 14.2878 5.47802 14.0852 5.65162L10.849 8.42374C10.7636 8.49692 10.7263 8.61176 10.7524 8.72118L11.7411 12.866C11.803 13.1256 11.5206 13.3308 11.2929 13.1917L7.6564 10.9705C7.5604 10.9119 7.43965 10.9119 7.34365 10.9705L3.70718 13.1917C3.47945 13.3308 3.19708 13.1256 3.25899 12.866L4.24769 8.72118C4.2738 8.61176 4.23648 8.49692 4.15105 8.42374L0.914889 5.65162C0.712228 5.47802 0.820086 5.14607 1.08608 5.12475L5.3336 4.78422C5.44573 4.77523 5.54342 4.70426 5.58662 4.60039L7.22303 0.665992Z'
                                    fill='#fff'
                                  ></path>
                                </svg>
                                <p className='ratingnum'>
                                  {job.technician.rating}
                                </p>
                              </div>
                            </div>

                            <h1 className='activetasknamee'>
                              {job.technician.name} {job.technician.lastName}
                            </h1>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className='thegap'></div>
                    {/* <button
                    className='mytaskviewtbtnn'
                    onClick={() => navigate(`/job/${job.id}`)}
                  >
                    View Details
                  </button> */}
                    <div className='activecrateat'>
                      <p> {formatWhatsAppTimestamp(job.createdAt)}</p>
                      <p className='acdivestat'>{job.status}</p>
                    </div>
                  </div>
                ))
              ) : (
                <p>You have no active jobs.</p>
              )}
            </div>
          )}
          {showorientation === "list" && (
            <div>
              {activeJobs.length > 0 ? (
                activeJobs.map((job) => (
                  <div
                    key={job.id}
                    className='thelasliksns'
                    onClick={() => navigate(`/client/job/${job.id}`)}
                  >
                    <h1 className='thelasjotit'>{job.jobtitle}</h1>
                    <p className='tehlasdes'>{job.jobdescription}</p>
                    <div className='teshimgname'>
                      <img
                        className='tablepix'
                        src={job.technician?.profileUrl}
                        alt=''
                      />
                      <span>
                        {job.technician?.name} {job.technician?.lastName}
                      </span>
                    </div>
                    <p className='tablesta'>{job.status}</p>
                    <p className='tabletimsa'>
                      {formatWhatsAppTimestamp(job.createdAt)}
                    </p>
                  </div>
                ))
              ) : (
                <p>You have no active jobs.</p>
              )}
            </div>
          )}
        </div>
      </DashboardLayout>
    </>
  );
}

export default ClientDashboard;
